import React, { useState } from "react";
import { track } from "@/lib/analytics";

const VIDEO_POSTER = "/video-poster.svg";

export default function VideoLesson({ lesson, onCompleted }) {
  const [progress, setProgress] = useState(0);
  const url = lesson.payload.video_url;
  return (
    <div>
      <video
        src={url}
        controls
        preload="metadata"
        poster={VIDEO_POSTER}
        className="w-full rounded-lg bg-black"
        data-testid="lesson-video"
        aria-label={`Video: ${lesson.title}`}
        onTimeUpdate={(e) => setProgress(e.currentTarget.currentTime / (e.currentTarget.duration || 1))}
        onEnded={() => track("lesson_video_completed", { lesson_id: lesson.id })}
      >
        <track kind="captions" srcLang="es" label="Español" />
      </video>
      <div className="mt-4 flex items-center justify-between">
        <p className="text-xs text-gray-500 font-mono">Reproducido: {Math.round(progress * 100)}%</p>
        <button
          onClick={onCompleted}
          disabled={progress < 0.9 && lesson.status !== "completed"}
          data-testid="lesson-complete-btn"
          aria-label="Marcar lección como completada"
          className="px-5 py-2 rounded-md bg-[#B84A0C] hover:bg-primary text-white text-sm font-semibold disabled:opacity-40"
        >
          Marcar como completada
        </button>
      </div>
      {lesson.status !== "completed" && progress < 0.9 && (
        <p className="mt-2 text-xs text-gray-500">Reproduce al menos el 90% para marcar como completada.</p>
      )}
    </div>
  );
}
